<bl-modal-content
  #content
  [title]="'出力条件'"
  [okButtonSetting]="okButtonSetting"
  [footerButtonType]="footerButtonType"
>
  <div class="pattern-modal-contents" body dnd-sortable>
    <div class="basic-condition-area">
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span class="select-label">残高種別</span>
            <span>:</span>
            <bl-select
              #balanceType
              [items]="balanceTypeItems"
              [(value)]="condition.balanceType"
            ></bl-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span>拠点</span>
            <span class="colon">:</span>
            <bl-code-input
              [(value)]="condition.organizationCodeStart"
              [option]="{enableBlank: true, valueProperty:'organizationCode', valueGuideProperty:'organizationCode'}"
              [maxlength]="6"
              [align]="'left'"
              [resource]="organizationResource"
            ></bl-code-input>
            <span class="input-group-btn">
              <button
                class="btn btn-default btn-sm"
                (click)="onShowGuide('organizationCodeStart')"
              >
                <span class="icon-icon_guide"></span>
              </button>
            </span>
            <span class="form-content__range">～</span>
            <bl-code-input
              [(value)]="condition.organizationCodeEnd"
              [option]="{enableBlank: true, valueProperty:'organizationCode', valueGuideProperty:'organizationCode'}"
              [maxlength]="6"
              [align]="'left'"
              [resource]="organizationResource"
            ></bl-code-input>
            <span class="input-group-btn">
              <button
                class="btn btn-default btn-sm"
                (click)="onShowGuide('organizationCodeEnd')"
              >
                <span class="icon-icon_guide"></span>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span>仕入先</span>
            <span class="colon">:</span>
            <bl-code-input
              [(value)]="condition.supplierCdStart"
              [option]="{enableBlank: true, valueProperty:'supplierCd', valueGuideProperty:'supplierCd'}"
              [maxlength]="9"
              [align]="'left'"
              [resource]="supplierResource"
            ></bl-code-input>
            <span class="input-group-btn">
              <button
                class="btn btn-default btn-sm"
                (click)="onShowGuide('supplierCdStart')"
              >
                <span class="icon-icon_guide"></span>
              </button>
            </span>
            <span class="form-content__range">～</span>
            <bl-code-input
              [(value)]="condition.supplierCdEnd"
              [option]="{enableBlank: true, valueProperty:'supplierCd', valueGuideProperty:'supplierCd'}"
              [maxlength]="9"
              [align]="'left'"
              [resource]="supplierResource"
            ></bl-code-input>
            <span class="input-group-btn">
              <button
                class="btn btn-default btn-sm"
                (click)="onShowGuide('supplierCdEnd')"
              >
                <span class="icon-icon_guide"></span>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span>対象年月</span>
            <span class="colon">:</span>
            <div class="form-item__date">
              <bl-date
                [era]="Era.Ad"
                [(value)]="condition.targetYearMonthStart"
                [dateMode]="DateMode.Month"
                [useCalendar]="'true'"
              ></bl-date>
            </div>
            <span class="form-content__range">～</span>
            <div class="form-item__date">
              <bl-date
                [era]="Era.Ad"
                [(value)]="condition.targetYearMonthEnd"
                [dateMode]="DateMode.Month"
                [useCalendar]="'false'"
              ></bl-date>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span>実績の無いデータの出力</span>
            <span class="colon">:</span>
            <bl-checkbox
              [label]="'出力する'"
              [checked]="condition.actualNoneOutputFlag"
              (changeEvent)="onChangeCheckboxEvent($event)">
            </bl-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12 col-lg-12">
          <div class="p-vo-detailed__contents__modalinput">
            <span>データ出力タイプ</span>
            <span class="colon">:</span>
            <bl-radio-group
              [(value)]=condition.accPayBalanceDataOutputType
              [items]="DATA_EXPORT_DIV_LIST"
              [groupType]="RADIO_GROUP_TYPE"
              (changeEvent)="onChangeDataExportDiv($event)">
            </bl-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/export-modal/debt-export-condition-modal/debt-export-condition-modal.component.html